import { useEffect, useState } from 'react'
import { TooltipTrigger } from '../../../../Provider/TooltipManager.js'

interface CSVColSelectorProps {
  mandatoryValues?: (string | undefined | null)[]
  label: string
  testId?: string
  onChange: (e: string) => void
  value: string
  options: string[]
  disabled?: boolean
  tooltip?: string
  unwrapped?: boolean
}

export const CSVColSelector = (props: CSVColSelectorProps) => {
  const [isValid, setIsValid] = useState(false)
  useEffect(() => {
    if (props.mandatoryValues == undefined || props.mandatoryValues.length <= 0) {
      setIsValid(true)
    } else if (props.mandatoryValues.find((x) => x !== undefined && x !== '')) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [props.mandatoryValues])

  const content = () => (
    <>
      <TooltipTrigger tooltip={props.tooltip}>
        <label className={'pr-2'}>
          {props.label}
          {props.mandatoryValues ? '*' : ''}
        </label>
      </TooltipTrigger>
      <select
        disabled={props.disabled === true}
        data-test-id={`csv-${props.testId}-id`}
        className={`select select-bordered select-sm ${isValid ? '' : 'border-red-500 '}`}
        onChange={(e) => props.onChange(e.target.value)}
        value={props.value}
      >
        <option value="">Select Column matching the criteria</option>
        {props.options.map((d: string, i: number) => (
          <option key={d + i} data-test-id={`option-${props.testId}-${i}`}>
            {d}
          </option>
        ))}
      </select>
    </>
  )

  if (props.unwrapped) {
    return content()
  }

  /* The cap bounds `justify-between`: the containing dialog is `w-fit`, so without it the gap between
     label and select grows to whatever width the dialog's widest other child happens to need. */
  return <div className="flex justify-between items-center gap-4 mb-2 max-w-xl">{content()}</div>
}
